import React from 'react';
import { Card } from './ui/card';
import { Award, Briefcase } from 'lucide-react';

const About = ({ data }) => {
  return (
    <section id="about" className="py-24 bg-[#0a0a0a] border-t border-[#2a2a2a]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">About Me</h2>
          <p className="text-[#a3a3a3] text-lg">A brief look into my background and what drives my passion for engineering.</p>
        </div>

        {/* Stats Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          <Card className="bg-[#161616] border-[#2a2a2a] p-8 hover:border-white transition-all duration-300">
            <div className="flex items-center gap-4">
              <div className="bg-white text-black p-4 rounded-lg">
                <Briefcase className="h-8 w-8" />
              </div>
              <div>
                <p className="text-5xl font-bold text-white">{data.personalInfo.yearsExperience}</p>
                <p className="text-[#a3a3a3] text-lg">Years Experience</p>
              </div>
            </div>
          </Card>

          <Card className="bg-[#161616] border-[#2a2a2a] p-8 hover:border-white transition-all duration-300">
            <div className="flex items-center gap-4">
              <div className="bg-white text-black p-4 rounded-lg">
                <Award className="h-8 w-8" />
              </div>
              <div>
                <p className="text-5xl font-bold text-white">{data.personalInfo.projectsCompleted}</p>
                <p className="text-[#a3a3a3] text-lg">Projects Completed</p>
              </div>
            </div>
          </Card>
        </div>

        {/* Professional Summary */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white mb-6">Professional Summary</h3>
          <p className="text-[#a3a3a3] text-lg leading-relaxed">
            {data.about.professionalSummary}
          </p>
        </div>

        {/* Core Strengths */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white mb-6">Core Strengths</h3>
          <div className="grid md:grid-cols-2 gap-4">
            {data.about.coreStrengths.map((strength, index) => (
              <div key={index} className="flex items-start gap-3">
                <span className="text-white mt-1.5 text-sm">▪</span>
                <p className="text-[#a3a3a3] leading-relaxed">{strength}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Leadership & Impact Highlights */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white mb-6">Leadership & Impact Highlights</h3>
          <ul className="space-y-4">
            {data.about.leadershipHighlights.map((highlight, index) => (
              <li key={index} className="text-[#a3a3a3] leading-relaxed flex items-start">
                <span className="text-white mr-3 mt-1">•</span>
                <span>{highlight}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Beyond Work */}
        <div className="bg-[#161616] border-[#2a2a2a] border p-8 rounded-lg">
          <h3 className="text-2xl font-bold text-white mb-4">Beyond Work</h3>
          <p className="text-[#a3a3a3] leading-relaxed">{data.about.beyondWork}</p>
        </div>

        {/* Expertise Areas */}
        <div className="mt-16 grid md:grid-cols-2 gap-8">
          {data.expertise.map((item, index) => (
            <Card key={index} className="bg-[#161616] border-[#2a2a2a] p-8 hover:border-white transition-all duration-300">
              <h3 className="text-xl font-bold text-white mb-4">{item.title}</h3>
              <p className="text-[#a3a3a3] leading-relaxed">{item.description}</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
